import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import './services/common/validation'

import { lazy, Suspense, useEffect, useState } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter, useLocation } from 'react-router-dom'

import { getBrandName } from './config'
import initI18n from './services/i18n'
import { store } from './services/redux'

const ConnectedApp = lazy(() => import('./App'))

const chooseBronsonBrand = (brand: string): string => {
  switch (brand) {
    case 'vwfs':
      return 'bluelabel'
    case 'xenakis':
      return 'default'
    case 'vw':
    case 'vwcv':
    case 'vwn':
      return 'vw6'
    default:
      return brand
  }
}

const getStyles = (brand: string) => {
  return import(`@vwfs-bronson/bronson-${chooseBronsonBrand(brand)}/dist/css/style.min.css`)
}

const PositionRestore = () => {
  const location = useLocation()

  useEffect(() => {
    if (location.hash && location.hash !== '') {
      setTimeout(() => {
        const id = location.hash.replace('#', '')
        const element = document.getElementById(id)
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' })
        }
      }, 0)
      return
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [location])

  return null
}

function Init() {
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    Promise.all([getStyles(getBrandName()), initI18n(getBrandName())]).then(() => {
      setLoaded(true)
    })
  }, [])

  return loaded ? (
    <Suspense fallback={null}>
      <Provider store={store}>
        <BrowserRouter>
          <PositionRestore />
          <ConnectedApp />
        </BrowserRouter>
      </Provider>
    </Suspense>
  ) : null
}

function render() {
  const rootElement = document.getElementById('root')

  if (!rootElement) {
    return
  }

  const root = createRoot(rootElement)
  root.render(<Init />)
}

if ((module as any).hot && typeof (module as any).hot.accept === 'function') {
  ;(module as any).hot.accept(() => {
    render()
  })
}

render()
